document.addEventListener("DOMContentLoaded", function(event){
        

    if(window.location.href.includes('/case-studies')) {
        checkIfFilterButtonIsActive();
        checkIfHasBeenFiltered();
    
    }

})

 
function appendFilterIdToUrl(e) {

    const id = e.target.closest('.arc-filter-btn').dataset.id;
    
    const param = 'tag';
    
    const url = new URL(window.location.href); // Get current URL
    
    let values = url.searchParams.get(param);  // Get existing values for the parameter

    // If the parameter already exists
    if (values) {
        let valueArray = values.split(','); // Split values into an array
        
        // Check if the value already exists in the array
        if (valueArray.includes(id)) {
            // If the value exists, remove it
            valueArray = valueArray.filter(val => val !== id);
        } else {
            // If the value doesn't exist, append it
            valueArray.push(id);
        }
        // Update or remove the parameter based on the resulting array
        if (valueArray.length > 0) {
            url.searchParams.set(param, valueArray.join(','));
        } else {
            url.searchParams.delete(param); // If no values left, remove the parameter
        }
    } else {
        // If the parameter doesn't exist, append the new value
        url.searchParams.append(param, id);
    }

    
    // Update the URL without reloading the page
    window.history.replaceState({}, '', url);
    window.location = url;
    // Add or Remove active class on button
    checkIfFilterButtonIsActive();

    
} 

function checkIfFilterButtonIsActive() {

    [...document.querySelectorAll('.arc-filter-btn')].forEach((btn) => { acivateButtonClass(btn); })

}

function acivateButtonClass(button) {
        
    let value = button.dataset.id;
    if (checkIfValueIsInParam('tag', value)) {
        button.classList.add('active');
    } else {
        button.classList.remove('active');
    }
}

function checkIfValueIsInParam(param, value) {

    const url = new URL(window.location.href); 

    let values = url.searchParams.get(param);



    if (values) {
            let valueArray = values.split(',');

            if (valueArray.includes(value)) {
                return true; 
            } 
    }
        
    return false;
}

function checkIfHasBeenFiltered(){
    const url = new URL(window.location.href); 

    let values = url.searchParams.get('tag');

    console.log(values);
    const all_btn = document.querySelector('.arc-filter-btn[data-id="all"]');
    if (values) {
        all_btn.classList.remove('active');
    } else {
        all_btn.classList.add('active');
    }
        
}

function removeAllFilters() {
 
    const url = new URL(window.location.href); // Get current URL

    url.searchParams.delete('tag');

    window.history.replaceState({}, '', url);
    window.location = url;

}